exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.name-box[data-v-6d0eb74b]{margin-bottom:10px}}.product-name[data-v-6d0eb74b]{font-size:28px;font-weight:500;position:relative}.product-name .wishlist-button[data-v-6d0eb74b]{position:absolute;right:0;top:-7px}@media (max-width: 767px){.product-name[data-v-6d0eb74b]{font-size:26px}}.price-wrapper[data-v-6d0eb74b]{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:10px;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}\n", ""]);

// exports
